import { QueryKeys } from "@lib/enums/QueryKeys";
import { useApi } from "@lib/helpers/useApi";
import { useAuth } from "@lib/auth/useAuth";
import { fetchStores, normalizeStore } from "../data";
import type { QueryConfig } from "@lib/helpers/useApi";
import type { StoreData } from "../types";

type UseStoresParams<TData = StoreData[]> = {
    country?: string;
    locale: string;
    isStoreLocatorPage?: boolean;
    queryConfig?: QueryConfig<StoreData[], TData>;
};

export const useStores = ({
    country,
    isStoreLocatorPage = false,
    locale,
    queryConfig = {},
}: UseStoresParams) => {
    const { session, status } = useAuth();
    const queryKey = [
        QueryKeys.getStores,
        country?.toUpperCase(),
        locale?.toUpperCase(),
        isStoreLocatorPage,
    ];

    const enabledByQueryConfig = queryConfig.enabled ?? true;

    const { data, ...rest } = useApi.useAsync(
        queryKey,
        async () => {
            const stores = await fetchStores(country, isStoreLocatorPage, session?.accessToken);
            return normalizeStore(stores, locale);
        },
        {
            ...queryConfig,
            enabled: enabledByQueryConfig && !!session?.accessToken && status === "authenticated",
        }
    );

    return { data, ...rest };
};
